import styled from 'styled-components';
import { FlexibleDiv } from '../../../../styled/common';
import { Breakpoints } from '../../../../styled/constants';
import { PlaceholderBlock } from '../../../../styled/placeholders.styled';

export const SkeletonCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 15px;
  box-sizing: border-box;
  background-color: ${({ theme: { colors } }) => colors.background.tertiary};
  width: 100%;
  border-radius: 21px;

  @media screen and (min-width: ${Breakpoints.tablet}px) {
    padding: 20px;
    width: calc(50% - 7.5px);
  }

  @media screen and (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    width: calc(25% - 15px);
  }
`;

export const SkeletonRow = styled(FlexibleDiv)`
  padding: 0 75px;

  @media screen and (min-width: ${Breakpoints.tablet}px) {
    padding: 0;
    gap: 34px;
  }
`;

export const SkeletonLogo = styled(PlaceholderBlock)`
  position: absolute;
  top: calc((100% - 55px) / 2);
  left: 15px;
  width: 55px;
  height: 55px;
  margin: 0;
  border-radius: 50%;

  @media screen and (min-width: ${Breakpoints.tablet}px) {
    position: static;
  }
`;

export const SkeletonTitle = styled(PlaceholderBlock)`
  width: 70%;
  height: 20px;
  margin: 0 0 8px;
`;

export const SkeletonOffersCount = styled(PlaceholderBlock)`
  width: 45%;
  height: 16px;
  margin: 0;
`;

export const SkeletonDescription = styled(PlaceholderBlock)`
  width: 100%;
  height: 14px;
  margin: 12px 0 0;
  padding: 0 75px;

  @media screen and (min-width: ${Breakpoints.tablet}px) {
    padding: 0;
    margin-top: 16px;
  }
`;

export const SkeletonDescriptionLine = styled(SkeletonDescription)`
  width: 85%;
  margin-top: 8px;
`;

export const SkeletonPhone = styled(PlaceholderBlock)`
  position: absolute;
  top: calc((100% - 55px) / 2);
  right: 15px;
  width: 55px;
  height: 55px;
  margin: 0;
  border-radius: 50%;

  @media screen and (min-width: ${Breakpoints.tablet}px) {
    display: none;
  }
`;
